import { useEffect, useRef } from "react";

export const AdBanner = ({
  slot = "auto",
  format = "auto",
  responsive = true,
  className = "",
}) => {
  const adRef = useRef(null);
  const pushedRef = useRef(false);

  useEffect(() => {
    // Guard against StrictMode double-invocation and multiple pushes on the same slot.
    if (pushedRef.current) return;
    try {
      if (typeof window !== "undefined" && adRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushedRef.current = true;
      }
    } catch (error) {
      // AdSense throws if the slot is already filled — swallow safely.
      console.error("AdSense error:", error);
    }
  }, []);

  return (
    <div className={`ad-banner my-6 ${className}`} data-testid="ad-banner">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-8611945344208543"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
    </div>
  );
};

export default AdBanner;
